import { Injectable } from '@angular/core';

@Injectable()
export class ContentService {

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/content.service.ts